import {
  FiCalendar,
  FiFileText,
  FiShield,
  FiCheckCircle,
  FiTrendingUp,
} from "react-icons/fi";
import { BiMailSend } from "react-icons/bi";

export const partnersServices = [
  {
    id: 1,
    icon: FiFileText, // Apply Now
    title: "Apply Now",
    desc: "Fill out a quick application to get started.",
  },
  {
    id: 2,
    icon: FiShield, // We Verify
    title: "We Verify",
    desc: "Our team carefully reviews your details.",
  },
  {
    id: 3,
    icon: FiCheckCircle, // Get Approved
    title: "Get Approved",
    desc: "Once verified, you’re officially a partner.",
  },
  {
    id: 4,
    icon: FiTrendingUp, // Start Growing
    title: "Start Growing",
    desc: "Access your dedicated panel & support to scale.",
  },
];

export const servicesData = [
  {
    id: 1,
    icon: FiShield,
    title: "Secured Payment",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
  },
  {
    id: 2,
    icon: FiCalendar,
    title: "Easy to use",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
  },
  {
    id: 3,
    icon: BiMailSend,
    title: "Support",
    desc: "The phrasal sequence of the is now so that many campaign and benefit",
  },
];
